import React from 'react';

import Whatsaap from '../assets/img/whatsapp.png';
import { Link } from "react-router-dom";


import M_logo1 from '../assets/img/facebook.svg';
import M_logo2 from '../assets/img/youtube.svg';
import M_logo3 from '../assets/img/instagram.svg';
import M_logo4 from '../assets/img/twitter.svg';

import sarlogo from '../assets/img/sarlogo.png';
import worklog from '../assets/img/worklogo.png';


const Footer = () => {
    return (
        <>
       
        <footer>
            
                <div className="footer_top">
                    <div className="container">
                    <div className="row footer_top_content">
                        <div className="col-sm-6">
                             <div className="footer_top_left">
                                 <img src={sarlogo} alt="" className='logom' />
                             </div>
                        </div>
                         <div className="col-sm-6">
                            <div className="footer_top_right">
                                <img src={worklog} alt="" className='logom' />
                            </div>
                         </div>
                        </div>
                    </div>
                </div>
                 <div className="footer_mid">
                    <div className="container">
                    <div className="foo_outmbr">
                        <div className="col-about-section">
                             <div className="footer_content">
                                <h3>About Us</h3>
                                <p>We design and deliver premium uniforms<br></br> tailored to your brand. From concept to<br></br> completion, every garment is crafted with<br></br>a deep understanding of your organization’s<br></br> identity, functional requirements, and the<br></br> impression you want to create.</p>
                             </div>
                        </div>
                         <div className="col-quiclink">
                             <div className="footer_content">
                                <h3>Quick Links</h3>
                                <ul>
                                    <li><a href="/">Home</a></li>
                                    <li><a href="/about-us">About Us</a></li>
                                    <li><a href="/design-studio">Design Studio</a></li>
                                    <li><a href="/project">Our Projects</a></li>
                                    <li><a href="/blog">Blogs</a></li>
                                    <li><a href="/contact">Contact Us</a></li>
                                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                                </ul>
                             </div>
                         </div>
                          <div className="col-product">
                             <div className="footer_content">
                                <h3>Our Products</h3>
                                <ul>
                                    <li><a href="/uniform-manufacturer/industrial">Industrial & Manufacturing</a></li>
                                    <li><a href="/uniform-manufacturer/hospitality-resorts">Hospitality & Resorts</a></li>
                                    <li><a href="/uniform-manufacturer/retail-brand-spaces">Retail & Corporate</a></li>
                                    <li><a href="/uniform-manufacturer/government-police-defense">Government, Police & Defense</a></li>
                                    <li><a href="/uniform-manufacturer/corporate-admin">Aviation</a></li>
                                    <li><a href="/uniform-manufacturer/healthcare-clinics-wellness">Healthcare, Clinics & Wellness</a></li>
                                    <li><a href="/uniform-manufacturer/educational-institutions">Educational Institutions</a></li>
                                </ul>
                             </div>
                          </div>
                           <div className="col-address">
                             <div className="footer_content">
                                <h3>Address</h3>
                                <p>First Floor, 1/72, <br></br>
                                  Poonamallee High Rd,<br></br> Nerkundram, Chennai, Tamil Nadu 600107, India</p>
                                <h3>Social media</h3>
                                <div className="sociel_icons">
                                    <img src={M_logo1} alt="" className='logom' />
                                    <img src={M_logo2} alt="" className='logom' />
                                    <img src={M_logo3} alt="" className='logom' />
                                    <img src={M_logo4} alt="" className='logom' />
                                </div>
                             </div>
                           </div>
                    </div>
                 </div>
                 </div>
                  <div className="footer_bottom">
                    <div className="row">
                        <p>© 2025 Workdayz - All rights reserved.</p>
                    </div>
                 </div>
        </footer>
        </>
    );
};

export default Footer;
